import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    status : false,
  },

  mutations: {

  },

  actions: {
    async limit({ commit }, products) {
      return await actionClient.post('member/activity/activity-limit', {products});
    }
  }


}
